import { Observable, combineLatest, map } from 'rxjs';

import { protocolsApi } from 'api/modules';
import { LendingMetrics, NetworkSlug, ProductSlug, VersionSlug } from 'domain/types';
import { hasOraclePrice, hasUnknownPrice } from 'domain/utils';

export type ProtocolStatsPageData = {
  balance: LendingMetrics['partialBalanceUSD'];
  balanceDayAgo: LendingMetrics['partialBalanceUSD'];
  hasOraclePrice: boolean;
  hasUnknownPrice: boolean;
  updatedAt: Date;
};

export function getProtocolStatsPageData({
  productSlug,
  versionSlug,
  network,
}: {
  productSlug: ProductSlug;
  versionSlug: VersionSlug;
  network: NetworkSlug;
}): Observable<ProtocolStatsPageData> {
  return combineLatest([
    protocolsApi.getProtocolMetrics$('latest', {
      productSlug,
      versionSlug,
      network,
    }),
    protocolsApi.getProtocolMetrics$('dayAgo', {
      productSlug,
      versionSlug,
      network,
    }),
  ]).pipe(
    map(([metrics, metricsDayAgo]) => ({
      updatedAt: new Date(metrics.timestamp),
      balance: metrics.partialBalanceUSD,
      balanceDayAgo: metricsDayAgo.partialBalanceUSD,
      hasOraclePrice: hasOraclePrice(metrics.assetTotals),
      hasUnknownPrice: hasUnknownPrice(metrics.assetTotals),
    })),
  );
}
